import { render, staticRenderFns } from "./CommentField.vue?vue&type=template&id=3d740c94"
import script from "./CommentField.vue?vue&type=script&lang=js"
export * from "./CommentField.vue?vue&type=script&lang=js"
import style0 from "./CommentField.vue?vue&type=style&index=0&id=3d740c94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports